export default {
  watch: {
    $route: {
      immediate: true,
      handler(value) {
        if (!value) {
          return
        }
        const { query } = value
        const { highway } = query
        if (highway) {
          this.$set(this, 'warehouse', +highway)
        }
      }
    },
    camp: {
      immediate: true,
      handler(value) {
        if (value) {
          this.$router.push({
            query: {
              warehouse: value
            }
          })
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/Purchases/warehouseRouteMixin.js